import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import LotBooking from "@/pages/LotBooking";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import SignLease from "@/pages/SignLease";
import BookingDetail from "@/pages/BookingDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <Toaster theme="light" position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/lot/:lotNumber" element={<LotBooking />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/booking/:bookingId" element={<BookingDetail />} />
          <Route path="/booking/:bookingId/sign" element={<SignLease />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
